<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div  v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('common.driverNum')">
                    <el-input
                      size="mini"
                      v-model="formInline.driverNum"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.driverName')">
                    <el-input
                      size="mini"
                      v-model="formInline.driverName"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.authorizes')">
                    <el-input
                      size="mini"
                      v-model="formInline.fingerNumV2"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                v-if="isPrimaryKey('NEWDRIVERFINGERPRINTFILE_EMPTY')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="deleteTerminal"
                  >{{$t('common.btn.clear')}}</el-button
                >
                <el-button
                v-if="isPrimaryKey('NEWDRIVERFINGERPRINTFILE_ADD')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="addTerminal"
                  >{{$t('DriverManagement.btn.addFinger')}}</el-button
                >
                <el-button v-if="isPrimaryKey('NEWDRIVERFINGERPRINTFILE_DOWN')" type="text" @click="downTerminal">{{$t('common.btn.download')}}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="driverNum"
            :label="$t('common.driverNum')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.driverNum"
              autocomplete="off"
              disabled
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
            prop="terminalType"
            :label="$t('OTAManagement.typeIdStr')+':'"
            :label-width="formLabelWidth"
          >
            <el-select
              @change="getTerminal"
              v-model="form.terminalType"
              :placeholder="$t('common.all')"
              size="small"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.terminalType"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item
            prop="terminalNum"
            :label="$t('common.terminalId')+':'"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="form.terminalNum"
              :placeholder="$t('common.all')"
              size="small"
              filterable
              :filter-method="filterMethod"
            >
              <el-option
                v-for="item in numList"
                :key="item.terminalId"
                :label="item.terminalId"
                :value="item.terminalId"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item
            prop="terminalNum"
            :label="$t('common.terminalId')+':'"
            :label-width="formLabelWidth"
          >
            <el-autocomplete
              size="small"
              v-model="form.terminalNum"
              :fetch-suggestions="querySearch"
              @select="handleSelect"
              autocomplete="off"
            ></el-autocomplete>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        width="1200px"
        :before-close="closeOperateDia"
        class="tableDialong"
        :title="$t('common.btn.operate')"
        :visible.sync="dialogOperateFormVisible"
        :close-on-click-modal="false"
      >
        <div class="zMsgTable">
          <i-table
            :list="authorizeList"
            :height="authorizeHeight"
            ref="authorizeTable"
            @handleSelectionChange="handleAuthorizeChange"
            :options="option"
            :columns="authorizeColumns"
            :operates="authorizeOperates"
          ></i-table>
          <IPagination
            ref="AuthorizePage"
            @PageFun="changeAuthorizeSize"
          ></IPagination>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import NewDriverFingerprintFile from "./NewDriverFingerprintFile.js";
export default NewDriverFingerprintFile;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>

